import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "../../_css/SessionSummaryPopup.module.css";
import { CustomButton, CustomButtonLight } from "../UI/CustomButtons";
import { formatHTMLResponse } from "../helper/formatters";

const SessionSummaryPopup = ({ show, onHide, data, openChat }) => {
  if (!data) return null;

  const handleHidePopup = (e) => {
    e.preventDefault();
    onHide();
  };

  const handleUpdateSession = (e) => {
    e.preventDefault();
    openChat();
    onHide();
  };



  return (
    <Modal
      style={{
        minWidth: "700px",
      }}
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title>Full Summary</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.titleRow}>
          <h5>{data.titleEn}</h5>
          <p>{data.subHeading}</p>
        </div>
        <div className={styles.summaryRow}>
          <label className={styles.summaryLabel}>
            Session Summary <span className="ai-tag">AI</span>
          </label>
          <p dangerouslySetInnerHTML={{ __html: formatHTMLResponse(data.summary) }}></p>
        </div>
        <p className={styles.trainedBy}>{`Trained by ${data.createdBy} on ${data.title}`}</p>
      </Modal.Body>
      <Modal.Footer>
        <CustomButtonLight
          onClick={(e) => handleHidePopup(e)}
          text="Cancel"
          width="48%"
        />
        <CustomButton
          onClick={(e) => handleUpdateSession(e)}
          text="Update Session"
          width="48%"
          icon="refresh"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SessionSummaryPopup;
